module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18010/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp2.svg"